import InfoIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Box,
  IconTypeMap,
  SxProps,
  Theme,
  Tooltip,
  TooltipProps,
} from "@mui/material";

export type TInfoTooltipProps = Omit<TooltipProps, "children"> & {
  textAriaLabel?: string;
  size?: IconTypeMap["props"]["fontSize"];
  tabIndex?: number;
  iconStyles?: SxProps<Theme>;
  iconContainerStyles?: SxProps<Theme>;
  severity?: "error" | "info";
};

const InfoTooltip = (props: TInfoTooltipProps) => {
  const {
    textAriaLabel,
    size = "small",
    tabIndex = 0,
    iconStyles,
    iconContainerStyles,
    severity = "info",
    ...tooltipProps
  } = props;

  return (
    <Tooltip arrow {...tooltipProps}>
      <Box
        tabIndex={tabIndex}
        component="span"
        role="note"
        sx={iconContainerStyles}
      >
        {severity === "error" ? (
          <WarningAmberIcon
            fontSize={size}
            color="error"
            sx={iconStyles}
            aria-label={textAriaLabel}
          />
        ) : (
          <InfoIcon
            fontSize={size}
            color="action"
            sx={iconStyles}
            aria-label={textAriaLabel}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default InfoTooltip;
